import { render } from "./PaymentTransactions.vue?vue&type=template&id=7c7cf488&scoped=true"
import script from "./PaymentTransactions.vue?vue&type=script&lang=js"
export * from "./PaymentTransactions.vue?vue&type=script&lang=js"

import "./PaymentTransactions.vue?vue&type=style&index=0&id=7c7cf488&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7cf488"]])

export default __exports__